import 'regenerator-runtime/runtime';

export function openPreviewPopUpWindow(e) {
    e?.preventDefault();
    const url = $(this).closest('.block-parts-catalogs__file-wrapper').find('.block-parts-catalogs__modal-preview iframe').attr('src');
    window.open(url, "_blank", "toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width=850,height=1200");
}

export function openPreviewModal(e) {
    e?.preventDefault();
    const partCatalogPreviewModal = $(this).closest('.block-parts-catalogs__file-wrapper').find('.block-parts-catalogs__modal-preview');
    if ($('.block-parts-catalogs__modal-preview.active').length) {
        return;
    }
    if (!partCatalogPreviewModal.hasClass('active')) {
        $('.block-parts-catalogs__modal-preview').removeClass('active');
    }
    partCatalogPreviewModal.addClass('active');
    $('body').addClass('modal-opened');
}

export function closePreviewModal(e, partCatalog) {
    e?.stopPropagation();
    partCatalog = partCatalog ?? $(this).closest('.block-parts-catalogs__modal-preview');
    partCatalog.removeClass('active');
    $('body').removeClass('modal-opened');
}

export function closePreviewModalOnClickOutside(e) {
    if ($(e.target).closest(".block-parts-catalogs__modal-preview.active").length === 0) {
        const activePartCatalog = $('.block-parts-catalogs__modal-preview.active');
        closePreviewModal(e, activePartCatalog);
    }
}

export function toggleFileListGroup(e) {
    $(this).closest('.block-parts-catalogs__groups').find('.block-parts-catalogs.active').not(this).toggleClass('active', false);
    $(this).toggleClass('active');
}

export default function init() {
    $(document).on('click', '.block-parts-catalogs dt', toggleFileListGroup);
    $(document).on('click', '.block-parts-catalogs.block-parts-catalogs--preview-popup .block-parts-catalogs__preview-button', openPreviewPopUpWindow);
    $(document).on('click', '.block-parts-catalogs.block-parts-catalogs--preview-modal .block-parts-catalogs__preview-button', openPreviewModal);
    $(document).on('click', '.block-parts-catalogs.block-parts-catalogs--preview-modal .block-parts-catalogs__modal-preview .close-modal', closePreviewModal);
    $(document).on('click', 'body.modal-opened', closePreviewModalOnClickOutside);
}